import React, { useState, useEffect, Fragment } from 'react';
import { useHistory } from "react-router-dom";
import './filter-left-panel.css';
import data from './items.json';
import FilterPanelMobilePopup from "../popups/filter-panel-mobile-popup";
import CartSvg from "../svg/cart";
import FacturePanierPopup from "../popups/facture-panier-popup";

function FilterLeftPanel(props) {

  const [isLoading, setIsLoading] = useState(true);
  const [isSortPopupOpen, setIsSortPopupOpen] = useState(false);
  const [isShoppingCartOpen, setIsShoppingCartOpen] = useState(false);
  const [checkboxes, setCheckboxes] = useState([]);
  // const [checkboxes, setCheckboxes] = useState('');
  const history = useHistory();


  useEffect(() => {
    if (props.categories) {
      setCheckboxes(props.categories)
    }
  }, [props.categories]);

  // useEffect(() => {
  //   const search = decodeURI(history.location.search);

  //   let checkboxes = data;
  //   let filts = "";
  //   checkboxes.forEach(data => (
  //     data.values.forEach(value => {
  //       if (search.includes(value.name)) {
  //         value['checked'] = true;
  //         // if (data.category === "Price Range") filts += value.value + ',';
  //       }
  //       else value['checked'] = false;
  //     })
  //   ))
  //   setCheckboxes(checkboxes);
  //   setIsLoading(false);

  //   if (filts === "") props.getProducts && props.getProducts();
  //   else {
  //     filts = filts.substring(0, filts.length - 1);
  //     props.applyFilter("{}", filts);
  //   }
  // }, []);

  const handleClose = () => {
    setIsSortPopupOpen(false);
  };

  const handleCloseCart = () => {
    setIsShoppingCartOpen(false);
  };

  // const removeAllFilter = () => {
  //   checkboxes.forEach((checkbox, categoryIndex) => {
  //     const newArray = checkbox.values.map(function (item) { return item.checked = false });
  //     // checkbox.values.map((value, valueIndex) => {
  //     // this.setState({
  //     //   [this.state.checkboxes[categoryIndex]]: newArray
  //     // })
  //     // })
  //   })
  //   // this.setState((prevState) => (
  //   //   prevState.checkboxes[value].values[lang].checked = !prevState.checkboxes[value].values[lang].checked,
  //   //   {
  //   //     checkboxes: prevState.checkboxes
  //   //   }
  //   // ));
  //   history.push({ pathname: this.props.location.pathname });
  //   this.props.getProducts && this.props.getProducts();
  // }

  const removeAllFilter = () => {
    checkboxes.forEach(checkbox => {
      checkbox.values.forEach(cur => {
        cur.checked = false;
      });
    });
    setCheckboxes(checkboxes);
    history.push({ pathname: history.location.pathname });
  }

  // const applyFilter = () => {
  //   //let currentUrlParams = new URLSearchParams(window.location.search);
  //   let filteredArray = []
  //   let filts = "";
  //   checkboxes.map(checkbox => (
  //     checkbox.values.forEach(value => {
  //       if (value.checked) {
  //         filteredArray.push(value.name);
  //         if (checkbox.category === "Price Range") filts += value.value + ',';
  //       }
  //     })
  //   ))
  //   if (filteredArray.length === 0) {
  //     history.push({
  //       pathname: history.location.pathname
  //     })
  //     props.getProducts();
  //   } else {
  //     filts = filts.substring(0, filts.length - 1);
  //     history.push({
  //       pathname: history.location.pathname,
  //       search: '?filtrer=' + filteredArray
  //     })
  //     props.applyFilter("{}", filts);
  //   }
  //   // currentUrlParams.set('filtre', ['allo', 'Ok']);
  //   // history.push("/" + this.props.match.params.idZec + "/" + this.props.match.params.language + "/achat-forfait" + "?" + currentUrlParams.toString());
  //   // console.log(history.location.pathname)
  // }

  const applyFilter = () => {
    //let currentUrlParams = new URLSearchParams(window.location.search);
    let filteredArray = []
    let filts = "";
    checkboxes.map(value => {
      if (value.checked) {
        filteredArray.push(value.description);
        // if (checkbox.category === "Price Range") filts += value.value + ',';
      }
    })
    if (filteredArray.length === 0) {
      history.push({
        pathname: history.location.pathname
      })
      props.getProducts();
    } else {
      filts = filts.substring(0, filts.length - 1);
      history.push({
        pathname: history.location.pathname,
        search: '?filtrer=' + filteredArray
      })
      props.applyFilter();
      // props.applyFilter("{}", filts);
    }
    // currentUrlParams.set('filtre', ['allo', 'Ok']);
    // history.push("/" + this.props.match.params.idZec + "/" + this.props.match.params.language + "/achat-forfait" + "?" + currentUrlParams.toString());
    // console.log(history.location.pathname)
  }

  // const handleOnChange = (event) => {
  //   const { value, lang } = event.target;
  //   // this.setState((prevState) => (
  //   //   prevState.checkboxes[value].values[lang].checked = !prevState.checkboxes[value].values[lang].checked,
  //   //   {
  //   //     checkboxes: prevState.checkboxes
  //   //   }
  //   // ));
  //   // this.setState((prevState) => ({
  //   //   checkboxes: {
  //   //     ...prevState.checkboxes,
  //   //     ...prevState.checkboxes[value].values[lang].checked = !prevState.checkboxes[value].values[lang].checked
  //   //   }
  //   // }));
  // };

  // const handleOnChange = (event) => {
  //   const { value, lang } = event.target;
  //   let copy = [...checkboxes];
  //   copy[value].values[lang].checked = !copy[value].values[lang].checked;
  //   setCheckboxes(copy)
  // };

  const handleOnChange = (id) => {
    let copy = [...checkboxes];
    copy[id].checked = !copy[id].checked;
    setCheckboxes(copy)
  };

  let results;
  if (props.totalItems === 0) results = 'Aucun résultat'
  if (props.totalItems === 1) results = 'Un résultat'
  else results = `${props.totalItems} résultats`
  return (
    <Fragment>
      {!isLoading &&
        <FilterPanelMobilePopup
          handleClose={handleClose}
          checkboxes={checkboxes}
          isOpen={isSortPopupOpen}
          onChange={handleOnChange}
          applyFilter={applyFilter}
          removeAllFilter={removeAllFilter}
        />
      }

      <FacturePanierPopup
        showByType={props.showByType}
        handleClose={handleCloseCart}
        isOpen={isShoppingCartOpen}
      />
      <div className="ais-filter-sort-block">
        <div className="d-flex justify-content-between">
          {/* <span>
              <div className="ais-Stats">
                <span className="ais-Stats-text">{results}</span>
              </div>
            </span> */}
          <span className="ais-filter-sort-cta">
            <span className="hide-text-mobile">{results}</span>
          </span>
          <span className="ais-filter-sort-cta" onClick={() => setIsShoppingCartOpen(true)}>
            <span className="hide-text-mobile">Panier</span>
            <span className="icon">
              <CartSvg width="22" height="22" />
            </span>
          </span>
          <span className="ais-filter-sort-cta" onClick={() => setIsSortPopupOpen(true)}>
            <span className="hide-text-mobile">Filtrer &amp; Trier</span>
            <span className="icon">
              <svg width="24" height="24" viewBox="0 0 12 14">
                <path d="M3.49219 4.5625C3.49219 4.42188 3.42188 4.28125 3.32812 4.16406C3.21094 4.07031 3.07031 4 2.92969 4H0.5625C0.398438 4 0.257812 4.07031 0.164062 4.16406C0.046875 4.28125 0 4.42188 0 4.5625V6.4375C0 6.60156 0.046875 6.74219 0.164062 6.83594C0.257812 6.95312 0.398438 7 0.5625 7H2.92969C3.07031 7 3.21094 6.95312 3.32812 6.83594C3.42188 6.74219 3.49219 6.60156 3.49219 6.4375V4.5625ZM0 8.3125C0 8.17188 0.046875 8.03125 0.164062 7.91406C0.257812 7.82031 0.398438 7.75 0.5625 7.75H2.92969C3.07031 7.75 3.21094 7.82031 3.32812 7.91406C3.42188 8.03125 3.49219 8.17188 3.49219 8.3125V10.1875C3.49219 10.3516 3.42188 10.4922 3.32812 10.5859C3.21094 10.7031 3.07031 10.75 2.92969 10.75H0.5625C0.398438 10.75 0.257812 10.7031 0.164062 10.5859C0.046875 10.4922 0 10.3516 0 10.1875V8.3125ZM2.92969 0.25C3.07031 0.25 3.21094 0.320312 3.32812 0.414062C3.42188 0.53125 3.49219 0.671875 3.49219 0.8125V2.6875C3.49219 2.85156 3.42188 2.99219 3.32812 3.08594C3.21094 3.20312 3.07031 3.25 2.92969 3.25H0.5625C0.398438 3.25 0.257812 3.20312 0.164062 3.08594C0.046875 2.99219 0 2.85156 0 2.6875V0.8125C0 0.671875 0.046875 0.53125 0.164062 0.414062C0.257812 0.320312 0.398438 0.25 0.5625 0.25H2.92969ZM4.80469 10.75C4.64062 10.75 4.5 10.7031 4.40625 10.5859C4.28906 10.4922 4.24219 10.3516 4.24219 10.1875V8.3125C4.24219 8.17188 4.28906 8.03125 4.40625 7.91406C4.5 7.82031 4.64062 7.75 4.80469 7.75H11.4375C11.5781 7.75 11.7188 7.82031 11.8359 7.91406C11.9297 8.03125 12 8.17188 12 8.3125V10.1875C12 10.3516 11.9297 10.4922 11.8359 10.5859C11.7188 10.7031 11.5781 10.75 11.4375 10.75H4.80469ZM4.24219 0.8125C4.24219 0.671875 4.28906 0.53125 4.40625 0.414062C4.5 0.320312 4.64062 0.25 4.80469 0.25H11.4375C11.5781 0.25 11.7188 0.320312 11.8359 0.414062C11.9297 0.53125 12 0.671875 12 0.8125V2.6875C12 2.85156 11.9297 2.99219 11.8359 3.08594C11.7188 3.20312 11.5781 3.25 11.4375 3.25H4.80469C4.64062 3.25 4.5 3.20312 4.40625 3.08594C4.28906 2.99219 4.24219 2.85156 4.24219 2.6875V0.8125ZM4.80469 7C4.64062 7 4.5 6.95312 4.40625 6.83594C4.28906 6.74219 4.24219 6.60156 4.24219 6.4375V4.5625C4.24219 4.42188 4.28906 4.28125 4.40625 4.16406C4.5 4.07031 4.64062 4 4.80469 4H11.4375C11.5781 4 11.7188 4.07031 11.8359 4.16406C11.9297 4.28125 12 4.42188 12 4.5625V6.4375C12 6.60156 11.9297 6.74219 11.8359 6.83594C11.7188 6.95312 11.5781 7 11.4375 7H4.80469Z"></path>
              </svg>
            </span>
          </span>
        </div>
      </div>
      <div className="left-panel-div">
        {checkboxes?.length &&
          <div className="ais-facet">
            <div className="ais-facet--header">
              Catégories
            </div>
            <div className="ais-refinement-list__wrapper collapsed">
              <div className="ais-refinement-list--list unselectable">
                {checkboxes.map((value, id) => {
                  return (
                    <div className="ais-facet--item" key={id}>
                      <div>
                        <div className="checkbox-filter ais-facet--checkbox">
                          <input
                            className="checkbox__element"
                            checked={value.checked}
                            type="checkbox"
                            id={value.description}
                            value={value.checked}
                            // value={categoryIndex}
                            // lang={valueIndex}
                            onChange={() => handleOnChange(id)}
                          />
                          <label className="checkbox__label" htmlFor={value.description} >
                          </label>
                        </div>
                        <label className="ais-facet--label" htmlFor={value.description}>
                          <span> {value.description} </span>
                          {/* <span className="ais-facet--count"> ({value.quantity}) </span> */}
                        </label>
                      </div>
                    </div>)
                })}
              </div>
            </div>
          </div>
        }

        {/* {!isLoading && checkboxes && checkboxes.map((data, categoryIndex) => {
          return (
            <div className="ais-facet" key={categoryIndex}>
              <div className="ais-facet--header">
                {data.category}
              </div>
              <div className="ais-refinement-list__wrapper collapsed">
                <div className="ais-refinement-list--list unselectable">
                  {data.values.map((value, valueIndex) => {
                    return (
                      <div className="ais-facet--item" key={valueIndex}>
                        <div>
                          <div className="checkbox-filter ais-facet--checkbox">
                            <input
                              className="checkbox__element"
                              checked={checkboxes[categoryIndex].values[valueIndex].checked}
                              type="checkbox"
                              id={value.name}
                              value={categoryIndex}
                              lang={valueIndex}
                              onChange={handleOnChange}
                            />
                            <label className="checkbox__label" htmlFor={value.name} >
                            </label>
                          </div>
                          <label className="ais-facet--label" htmlFor={value.name}>
                            <span> {value.name} </span>
                            <span className="ais-facet--count"> ({value.quantity}) </span>
                          </label>
                        </div>
                      </div>)
                  })}
                </div>
              </div>
            </div>
          )
        })} */}
        <div className="button-filter-left-panel unselectable">
          <span onClick={applyFilter}>APPLIQUEZ LES FILTRES</span>
        </div>
      </div>
    </Fragment>
  );

}

FilterLeftPanel.defaultProps = {
  data: data
}

export default FilterLeftPanel;